export default "__VITE_ASSET__6yyfHzJg__"